import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ProductsDropDownData } from './products-drop-down-model';

export class ProductsDropDownDataResponseModel extends GlobalResponseObject{
    data?: ProductsDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //ProductsDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ProductsDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
